(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('factoryLineOfBalance', factoryLineOfBalance);

	factoryLineOfBalance.$inject = ['$rootScope', '$scope', '$timeout', 'factorySettingService', 'storeService', 'siteService'];

	function factoryLineOfBalance($rootScope, $scope, $timeout, factorySettingService, storeService, siteService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var usePoConfirmations = siteService.getFactoryUsesConfirmations(adminConfig.factory.id);

		vm.saveSettings = saveSettings;
		vm.onClick = onClick;
		vm.onChange = onChange;
		vm.lobPoStatusRank = 9999;
		vm.lobSupplyDate = '';
		vm.lobAdditionalSupplyTypes = null;
		vm.lobExcludePastDueSupply = '';
		vm.lobRequirementType = '';

		vm.lobPoStatusOptions = usePoConfirmations ? [
			{
				display: '1. Unconfirmed (and 2-3 below)',
				value: 1
			},
			{
				display: '2. Confirmed (and 3 below)',
				value: 2
			},
			{
				display: '3. In Transit',
				value: 3
			}
		] : [
			{
				display: '1. Unconfirmed (and #2-6 below)',
				value: 1
			},
			{
				display: '2. Confirmed (and #3-6 below)',
				value: 2
			},
			{
				display: '3. Committed in ERP (and #4-6 below)',
				value: 3
			},
			{
				display: '4. Committed in LeanDNA (and #5-6 below)',
				value: 4
			},
			{
				display: '5. Shipped - Tracking in LeanDNA (and #6 below)',
				value: 5
			},
			{
				display: '6. Shipped - ASN',
				value: 6
			}
		];

		vm.lobSupplyDateOptions = [
			{
				display: 'Expected delivery date (ERP)',
				value: 'ErpExpectedDate'
			},
			{
				display: 'Current supplier commit date (ERP)',
				value: 'ErpCommitDate'
			},
			{
				display: 'Manually entered date, fallback to ERP date',
				value: 'ManualErpExpectedDate'
			}
		];

		vm.lobAdditionalSupplyTypesOptions = [
			{
				display: 'Include purchase requisitions',
				value: 'IncludePRs'
			},
			{
				display: 'Include planned production orders',
				value: 'IncludePPOs'
			}
		];

		vm.lobRequirementTypeOptions = [
			{
				display: 'Forecast',
				value: 'Forecast'
			},
			{
				display: 'Production Order',
				value: 'ProductionOrder'
			},
			{
				display: 'Planned Production Order',
				value: 'PlannedProductionOrder'
			},
			{
				display: 'Transfer Order',
				value: 'TransferOrder'
			},
			{
				display: 'Planned Transfer Order',
				value: 'PlannedTransferOrder'
			},
			{
				display: 'Customer Order',
				value: 'CustomerOrder'
			},
			{
				display: 'Inventory Expiration',
				value: 'InventoryExpiration'
			},
			{
				display: 'All Other Requirements',
				value: 'AllOtherReqs'
			}
		];

		function onClick(opt) {

			var element = $('#poStatusOption' + opt.value);
			if (!element.length > 0) {
				return;
			}

			var box = element[0];
			var rank = opt.value;
			if (box.checked) {
				vm.lobPoStatusRank = rank;
			} else {
				if (rank === vm.lobPoStatusRank) {
					vm.lobPoStatusRank = 9999;
				} else {
					box.checked = true;
					vm.lobPoStatusRank = rank;
				}
			}
		}

		function onChange(value, isChecked, variableName) {
			switch(variableName){
			case 'lobRequirementType':
				if (isChecked) {
					vm.lobRequirementType.push(value);
				} else {
					var index =	vm.lobRequirementType.indexOf(value);
					if (index > -1) {
						vm.lobRequirementType.splice(index, 1);
					}
				}
				break;
			case 'lobAdditionalSupplyTypes':
				if (isChecked) {
					vm.lobAdditionalSupplyTypes.push(value);
				} else {
					var index =	vm.lobAdditionalSupplyTypes.indexOf(value);
					if (index > -1) {
						vm.lobAdditionalSupplyTypes.splice(index, 1);
					}
				}
				break;
			}
		}

		init();

		function init() {
			factorySettingService.getFactorySettings(['PROCUREMENT_LOB_PO_STATUS', 'PROCUREMENT_LOB_SUPPLY_DATE',
				'PROCUREMENT_LOB_ADDITIONAL_SUPPLY_TYPES', 'PROCUREMENT_LOB_EXCLUDE_PAST_DUE_SUPPLY', 'PROCUREMENT_LOB_REQUIREMENT_TYPE'], adminConfig.factory.id)
				.then(function (settings) {
					vm.lobPoStatusRank = settings.PROCUREMENT_LOB_PO_STATUS;
					vm.lobSupplyDate = settings.PROCUREMENT_LOB_SUPPLY_DATE;
					vm.lobAdditionalSupplyTypes = settings.PROCUREMENT_LOB_ADDITIONAL_SUPPLY_TYPES === '' ? [] : settings.PROCUREMENT_LOB_ADDITIONAL_SUPPLY_TYPES.split(',');
					vm.lobExcludePastDueSupply = settings.PROCUREMENT_LOB_EXCLUDE_PAST_DUE_SUPPLY;
					vm.lobRequirementType = settings.PROCUREMENT_LOB_REQUIREMENT_TYPE.split(',');
				});
		}

		function saveSettings() {
			factorySettingService.saveFactorySettings({
				PROCUREMENT_LOB_PO_STATUS: vm.lobPoStatusRank,
				PROCUREMENT_LOB_SUPPLY_DATE: vm.lobSupplyDate,
				PROCUREMENT_LOB_ADDITIONAL_SUPPLY_TYPES: vm.lobAdditionalSupplyTypes.join(','),
				PROCUREMENT_LOB_EXCLUDE_PAST_DUE_SUPPLY: vm.lobExcludePastDueSupply,
				PROCUREMENT_LOB_REQUIREMENT_TYPE: vm.lobRequirementType.join(',')
			}, adminConfig.factory.id).then(function (response) {
				if (response === 'Settings saved successfully') {
					$rootScope.$emit('toast', {
						'message': response,
						'success': true
					});
				}
			});
		}
	}
})();

